import {useEffect} from 'react';

const SCRIPT_ID='esyoh-widget-js';
const SCRIPT_SRC='https://www.esyoh.com/clients/js/widget.js?ver=3.0.0';
const DOMAIN_ID='medicalcodingclassesonline.com';

function ESYOHWidgets({widgetId}) {
  useEffect(()=> {
    if (!widgetId) return undefined;

    const initializeWidget=()=> {
      if (window.ESY?.Widget) {
        new window.ESY.Widget({
          domain_id: DOMAIN_ID,
          widget_id: widgetId,
        });
      }
    };

    const existingScript=document.getElementById(SCRIPT_ID);

    if (existingScript) {
      if (window.ESY?.Widget) {
        initializeWidget();
      } else {
        existingScript.addEventListener('load',initializeWidget);
      }

      return ()=> existingScript.removeEventListener('load',initializeWidget);
    }

    const script=document.createElement('script');
    script.id=SCRIPT_ID;
    script.src=SCRIPT_SRC;
    script.async=true;
    script.addEventListener('load',initializeWidget);
    document.body.appendChild(script);

    return ()=> script.removeEventListener('load',initializeWidget);
  },[widgetId]);

  return <div className="esy_widget_container" />;
}

export default ESYOHWidgets;